export function Tab(props:{value: "zuschusse" | "darlehen", id: string, panel_id: string, label: string, count:number, active_tab: "zuschusse" | "darlehen", set_active_tab: (string) => void}){
  const is_active = props.value == props.active_tab;
    return <div
        id={props.id}
        role="tab" 
        aria-controls={props.panel_id}
        tabIndex={0} 
        className={"tabs__header_item " + (props.count == 0 ? " tabs__header_item--empty ": "") + (is_active ? "tabs__header_item--active" : "")} 
        aria-selected={is_active} 
        onClick={()=>{props.set_active_tab(props.value)}}
        onKeyUp={(event)=>{
          if(event.code != "Enter" && event.code != " "){return;}
          props.set_active_tab(props.value)
        }}
      >
      {props.label} ({props.count})
    </div>
  }